export const ACTIONS = {
  INVOICE_ROW_CREATE_START: 'INVOICE_ROW_CREATE_START',
  INVOICE_ROW_CREATE_SUCCESS: 'INVOICE_ROW_CREATE_SUCCESS',
  INVOICE_ROW_CREATE_FAILURE: 'INVOICE_ROW_CREATE_FAILURE',
  INVOICE_ROW_CREATE_RESET: 'INVOICE_ROW_CREATE_RESET',

  INVOICE_ROW_UPDATE_START: 'INVOICE_ROW_UPDATE_START',
  INVOICE_ROW_UPDATE_SUCCESS: 'INVOICE_ROW_UPDATE_SUCCESS',
  INVOICE_ROW_UPDATE_FAILURE: 'INVOICE_ROW_UPDATE_FAILURE',
  INVOICE_ROW_UPDATE_RESET: 'INVOICE_ROW_UPDATE_RESET',

  INVOICE_ROW_DELETE_START: 'INVOICE_ROW_DELETE_START',
  INVOICE_ROW_DELETE_SUCCESS: 'INVOICE_ROW_DELETE_SUCCESS',
  INVOICE_ROW_DELETE_FAILURE: 'INVOICE_ROW_DELETE_FAILURE',
  INVOICE_ROW_DELETE_RESET: 'INVOICE_ROW_DELETE_RESET',

  INVOICE_ROW_FETCH_START: 'INVOICE_ROW_FETCH_START',
  INVOICE_ROW_FETCH_SUCCESS: 'INVOICE_ROW_FETCH_SUCCESS',
  INVOICE_ROW_FETCH_FAILURE: 'INVOICE_ROW_FETCH_FAILURE',
  INVOICE_ROW_FETCH_RESET: 'INVOICE_ROW_FETCH_RESET',

  INVOICE_ROWS_FETCH_START: 'INVOICE_ROWS_FETCH_START',
  INVOICE_ROWS_FETCH_SUCCESS: 'INVOICE_ROWS_FETCH_SUCCESS',
  INVOICE_ROWS_FETCH_FAILURE: 'INVOICE_ROWS_FETCH_FAILURE',
  INVOICE_ROWS_FETCH_RESET: 'INVOICE_ROWS_FETCH_RESET',

  INVOICE_ROW_RESET: 'INVOICE_ROW_RESET',
};
